import mappedItemTypes from 'services/items/mappedItemTypes';
import { PortfolioItemSelectStep } from '../PortfolioItemSelectStep';
import { PCW_STEPS } from '../constants';

export function ForwardCurveConstraintsStep() {
    return (
        <PortfolioItemSelectStep
            stepId={PCW_STEPS.PCW_FORWARD_CURVES_CONSTRAINTS_STEP_ID}
            itemTypeIds={[mappedItemTypes.FORWARD_CURVE_CONSTRAINTS.id]}
        />
    );
}
